<template>
  <v-container>
    <v-card class="mb-3 mt-5">
      <v-container>
        <v-row align="center" justify="center">
          <h1 class="display-2 pt-5">Contact</h1>
        </v-row>
        <v-row class="mt-2 " >
          <p class="headline mx-auto">Have a question?</p>
          
        </v-row>
        <v-row></v-row>
        <v-divider class="pb-5"></v-divider>
        <v-form
          class="pl-3 pr-3"
          v-model="valid"
          ref="contactForm"
          lazy-validation
        >
          <v-row>
            <v-col cols="12" sm="6" md="4" class="pb-0 pt-0">
              <v-text-field
                label="Name *"
                v-model="name"
                outlined
                color="red"
                :rules="nameRules"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4" class="pb-0 pt-0">
              <v-text-field
                label="Email *"
                v-model="email"
                outlined
                color="red"
                :rules="emailRules"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="4" class="pb-0 pt-0">
              <v-text-field
                label="Phone"
                v-model="phone"
                outlined
                color="red"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4" class="pb-0 pt-0">
              <v-text-field
                label="Subject"
                v-model="subject"
                outlined
                color="red"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="pb-0 pt-0">
              <v-textarea
                v-model="message"
                outlined
                color="red"
                label="Message *"
                :rules="messageRules"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="4" class="pt-0">
              <v-btn large color="error" @click="sendMessage"
                >Send Message</v-btn
              >
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card>
    <v-snackbar v-model="showSnackbar" :color="snackbarColor">
      {{ snackbarText }}
      <v-btn text @click="showSnackbar = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      showSnackbar: false,
      snackbarColor: "",
      snackbarText: "",
      valid: true,
      name: "",
      nameRules: [v => !!v || "Name is required"],
      email: "",
      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+\..+/.test(v) || "E-mail must be valid"
      ],
      phone: "",
      subject: "",
      message: "",
      messageRules: [v => !!v || "Message is required"]
    };
  },
  methods: {
    async sendMessage() {
      try {
        await this.$refs.contactForm.validate();
        if (this.valid) {
          await axios.post(
            "https://5o1hidfn19.execute-api.us-east-1.amazonaws.com/dev/slackContactForm",
            {
              name: this.name,
              email: this.email,
              phone: this.phone,
              subject: this.subject,
              message: this.message
            }
          );

          this.$refs.contactForm.reset();
          this.$refs.contactForm.resetValidation();

          this.snackbarText = "Message sent successfully";
          this.snackbarColor = "success";
          this.showSnackbar = true;
        }
      } catch (error) {
        this.snackbarText = "ERROR: Message not sent";
        this.snackbarColor = "red";
        this.showSnackbar = true;
      }
    }
  }
};
</script>

<style scoped>
.no-vertical-padding {
  padding-bottom: 0;
  padding-top: 0;
}
</style>
